import "./cookies-banner.scss";
import React from "react";
import { Link } from "gatsby";

const CookiesBanner = ({ onClick }) => {
  return (
    <div className="cookies-banner">
      <div className="container">
        <div className="row">
          <div className="col-lg-5 col-md-6">
            <div className="cookies-banner__text">
              <strong>Twoja prywatność</strong>
              <br />
              Wraz z naszymi partnerami przechowujemy i/lub uzyskujemy dostęp do
              informacji w urządzeniu, takich jak unikatowe identyfikatory w
              plikach cookie, w celu przetwarzania danych osobowych. W naszej
              Polityce Prywatności użytkownik może dowiedzieć się w jakim
              zakresie i jakim podmiotom mogą zostać przekazywane dane.
              Użytkownik ma prawo do sprzeciwu w przypadku występowania prawnie
              uzasadnionych interesów.
            </div>
          </div>
          <div className="col-lg-5 col-md-6">
            <div className="cookies-banner__text">
              <strong>Jakie dane przetwarzamy:</strong>
              <br />
              Użycie dokładnych danych geolokalizacyjnych. Aktywne skanowanie
              charakterystyki urządzenia do celów identyfikacji. Przechowywanie
              informacji na urządzeniu lub dostęp do nich. Spersonalizowane
              reklamy i treści, pomiar reklam i treści, opinie odbiorców, rozwój
              produktu.
            </div>
          </div>
          <div className="col-lg-2">
            <div className="cookies-banner__buttons-container">
              <button
                type="button"
                onClick={onClick}
                className="btn btn--white btn--strong"
              >
                Akceptuję
              </button>
              <Link
                to="/ogolne-warunki-sprzedazy-i-gwarancji#polityka-prywatnosci"
                className="cookies-banner__text-link"
              >
                Polityka prywatności
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiesBanner;
